import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import ReactDOM from "react-dom";

const steps = [
  {
    selector: "#descarga-excel-base",
    content:
      "Comenzá descargando el Excel base. Luego deberás completarlo antes de subirlo al sistema."
  },
  {
    selector: "#selecciona-categoria",
    content:
      "Selecciona entre una de las categorías disponibles, 'Inmueble' o 'Comercio'."
  },
  {
    selector: "#subir-archivo",
    content:
      "Sube el archivo xls con la información deseada, en el formato brindado."
  },
  {
    selector: "#enviar-archivo",
    content:
      "Luego de 'Enviar', se descargará el xls procesado. En ese archivo deberás eliminar las filas que no deseas y agregar los CUIT correspondientes."
  }
];

export default function XlsGeneratorTour({ onFinish }) {
  const [current, setCurrent] = useState(0);
  const [coords, setCoords] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const element = document.querySelector(steps[current].selector);
    if (!element) return;

    element.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });

    const rect = element.getBoundingClientRect();
    const margin = 12;

    setCoords({
      top: rect.top - margin,
      left: rect.left
    });

    // Highlight estable
    element.style.outline = "3px solid #1890ff";
    element.style.borderRadius = "6px";
    element.style.zIndex = "1002";
    element.style.position = "relative";

    return () => {
      element.style.outline = "";
      element.style.borderRadius = "";
      element.style.zIndex = "";
      element.style.position = "";
    };
  }, [current]);

  //Para cerrar con "ESC"
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onFinish();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onFinish]);

  return ReactDOM.createPortal(
    <>
      <div style={overlayStyle} />

      <div
        style={{
          ...tooltipStyle,
          top: coords.top,
          left: coords.left
        }}
      >
        <p style={{ marginBottom: 12 }}>
          {steps[current].content}
        </p>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {current > 0 && (
            <Button variant="primary" onClick={() => setCurrent((c) => c - 1)}>
              Atrás
            </Button>
          )}

          {current < steps.length - 1 ? (
            <Button variant="primary" onClick={() => setCurrent((c) => c + 1)}>
              Siguiente
            </Button>
          ) : (
            <Button variant="primary" onClick={onFinish}>
              Finalizar
            </Button>
          )}
        </div>
      </div>
    </>,
    document.body
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.55)",
  zIndex: 1000
};

const tooltipStyle = {
  position: "fixed",
  transform: "translateY(-100%)",
  background: "#fff",
  padding: "16px",
  borderRadius: "10px",
  zIndex: 1001,
  width: "300px",
  boxShadow: "0 8px 30px rgba(0,0,0,0.25)"
};
